export const apiName: string = 'servicos';
export const servicosRoute: string = 'servicos';
export const servicosStorage: string = 'servicos';
export const servicosModuleName: any = {plural: 'Serviços', single: 'Serviço'};

//servico planos
export const servicoPlanosApiName: string = 'servicos-planos-manutencoes';
export const servicoPlanosStorage: string = 'servicoPlanos';
export const servicoPlanosComponentName: any = {plural: 'Serviços', single: 'Serviço'};

//servico ordem servico
export const servicoOrdensServicoApiName: string = 'servicos-ordens-servicos';


//servico bens
export const servicoBensApiName: string = 'servicos-bens';
export const servicoBensStorage: string = 'servicoBens';

export const servicosQuery: any = {
    "where":{
        "ativo":true,
        "descricao":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"descricao"
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/shared/data.service.ts
 **/